export enum FilterType {
  Search = 'SEARCH',
  CustomSearch = 'CUSTOM_SEARCH',
  Select = 'SELECT',
  ToggleGroup = 'TOGGLE_GROUP',
  SearchChips = 'SEARCH_CHIPS',
  DateTimeRange = 'DATE_TIME_RANGE',
}
